import React, { useState } from 'react'
import {
  Box,
  Typography,
  Collapse
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { LFWeb } from 'src/assets/leadFinder/LFWeb'

export const CompanyListTab = ({ company }) => {
  const [isCompanyInfoOpen, setIsCompanyInfoOpen] = useState(true)
  const [isAdditionalInfoOpen, setIsAdditionalInfoOpen] = useState(true)

  return (
    <Box mt={2}>
      <Box sx={{ padding: '0px 20px' }}>
        <Box mb={2}>
          <Typography variant='h6' sx={{ fontWeight: '700' }}>
            {company.name || 'N/A'}
          </Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{
              color: '#8181B0',
              fontWeight: '500'
            }}
          >
            {company.industry || 'Industry not specified'}
          </Typography>
        </Box>
      </Box>

      {/* Company Information Section */}
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          onClick={() => setIsCompanyInfoOpen(!isCompanyInfoOpen)}
          sx={{
            cursor: 'pointer',
            background: '#F2F4F6',
            overflow: 'hidden',
            padding: '5px 20px'
          }}
        >
          <Box display='flex' alignItems='center' sx={{ gap: 2 }}>
            <Typography variant='subtitle1' fontWeight='bold'>
              Company Information
            </Typography>
          </Box>
          {isCompanyInfoOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
        <Collapse in={isCompanyInfoOpen}>
          <Box mt={1} pl={2}>
            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Website</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.website || 'N/A'}
                </Typography>
                {company.website && (
                  <Box
                    component='a'
                    onClick={() => window.open(company.website, '_blank')}
                    sx={{
                      color: '#3F50F8',
                      cursor: 'pointer'
                    }}
                  >
                    <LFWeb />
                  </Box>
                )}
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Domain</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.domain || 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>LinkedIn URL</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.linkedin_url || 'N/A'}
                </Typography>
                {company.linkedin_url && (
                  <Box
                    component='a'
                    onClick={() => window.open(company.linkedin_url, '_blank')}
                    sx={{
                      color: '#3F50F8',
                      cursor: 'pointer'
                    }}
                  >
                    <LFWeb />
                  </Box>
                )}
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Location</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {[company.city, company.state, company.country].filter(Boolean).join(', ') || 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>

      {/* Additional Details Section */}
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          onClick={() => setIsAdditionalInfoOpen(!isAdditionalInfoOpen)}
          sx={{
            cursor: 'pointer',
            background: '#F2F4F6',
            overflow: 'hidden',
            padding: '5px 20px'
          }}
        >
          <Box display='flex' alignItems='center' sx={{ gap: 2 }}>
            <Typography variant='subtitle1' fontWeight='bold'>
              Additional Details
            </Typography>
          </Box>
          {isAdditionalInfoOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
        <Collapse in={isAdditionalInfoOpen}>
          <Box mt={1} pl={2}>
            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Employee Count</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.employee_count || 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Annual Revenue</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.annual_revenue || 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '12px' }}>
              <Typography variant='body2' sx={{ marginBottom: '5px' }}>
                <strong>Founded Year</strong>
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component='span'
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#E7F0FF',
                    color: '#3F50F8',
                    borderRadius: '4px',
                    padding: '2px 8px',
                    maxWidth: 'fit-content',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {company.founded_year || 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>
    </Box>
  )
}
